import React from 'react';

import { Table } from 'react-bootstrap';
import moment from 'moment';

import DollarOutput from '../../utils/DollarOutput';
import Sorter from '../../utils/Sorting/Sorter';
import { isMobileResolution } from '../../../infrastructure/utils/common';
import { Order } from '../../../types/Order';
import { Party } from '../../../types/Party';

import PartyOrdersListMobile from './PartyOrdersListMobile';

type Props = {
  activeSort: unknown;
  changeSort: (val) => void;
  handleOnClick: (val) => void;
  orders: Order[];
  party: Party;
};

const PartyOrdersList = ({
  activeSort,
  changeSort,
  handleOnClick,
  orders,
  party,
}: Props) => {
  const onClick = event => {
    event.preventDefault();
    handleOnClick(event.currentTarget.getAttribute('href'));
  };

  const handleChangeSort = event => {
    event.stopPropagation();
    event.preventDefault();
    changeSort(event.currentTarget.getAttribute('name'));
  };

  const getEventDate = order => {
    return `${moment(order.startDateTime)
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      .tz(party.tz)
      .format('MM/DD/YY hh:mm A ')} - ${moment(order.endDateTime)
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      .tz(party.tz)
      .format('MM/DD/YY hh:mm A ')}`;
  };

  const getOrderPlacedDate = order => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    return moment(order.created).tz(party.tz).format('MM/DD/YY hh:mm A z');
  };

  const activeOrders = orders.filter(order => order.status !== 'Draft');

  if (isMobileResolution()) {
    return (
      <PartyOrdersListMobile
        orders={activeOrders}
        getEventDate={getEventDate}
        getOrderPlacedDate={getOrderPlacedDate}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        party={party}
        onOrderClick={onClick}
      />
    );
  }

  return (
    <div className='orderslist'>
      <Table hover>
        <thead>
          <tr>
            <th>BACH Confirmation Code</th>
            <th>Event Dates</th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='totalPrice'
              className='sortColumn'
              onClick={handleChangeSort}
            >
              Price <Sorter activeSort={activeSort} name='totalPrice' />
            </th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed}
              // @ts-ignore
              name='status'
              className='sortColumn'
              onClick={handleChangeSort}
            >
              Status <Sorter activeSort={activeSort} name='status' />
            </th>
            <th>Date Created</th>
          </tr>
        </thead>
        <tbody>
          {activeOrders.map(order => (
            <tr
              key={order.id}
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              href={`/orders/${order.id}`}
              className='listrow'
              onClick={onClick}
            >
              <td>{order.bachConfirmation}</td>
              <td>{getEventDate(order)}</td>
              <td>
                <DollarOutput value={order.totalPrice} />
              </td>
              <td>{order.status}</td>
              <td>{getOrderPlacedDate(order)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PartyOrdersList;
